import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { services } from "@/config/site";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-charcoal py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Eyebrow dark>What We Do</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-white">
            Complete event solutions,
            <span className="italic text-champagne"> beautifully executed.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="group relative overflow-hidden rounded-2xl border border-champagne/15 bg-white/[0.03] p-7 transition-colors duration-500 hover:border-champagne/50 hover:bg-white/[0.06]"
            >
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl border border-champagne/25 bg-champagne/10 transition-colors duration-500 group-hover:bg-champagne group-hover:border-champagne">
                <Icon className="h-6 w-6 text-champagne transition-colors duration-500 group-hover:text-charcoal" strokeWidth={1.4} />
              </div>
              <h3 className="font-display text-2xl text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{s.desc}</p>
              <span className="pointer-events-none absolute -right-6 -bottom-6 font-display text-6xl text-white/[0.04] transition-all duration-500 group-hover:text-champagne/10">
                {String(i + 1).padStart(2, "0")}
              </span>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
